import { call, put } from "redux-saga/effects";
import Api from "common/api";
import constants from "./constants";

export default {
  GetAllAdsList: function* () {
    const __name = constants.GET_ALL_ADS_LIST;
    try {
      const res = yield call(Api.getAllAdsList);
      console.log("GetAllAdsList", res);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  ChangeConnectedAds: function* (data) {
    const __name = constants.CHANGE_CONNECTED_ADS;
    console.log("ChangeConnectedAds data", data);
    try {
      const result = yield call(Api.changeConnectedAds, data.g_ads_id, data.fb_id);
      console.log("ChangeConnectedAds result", result);
      yield put({ type: `FETCH_SUCCESS_${__name}`, data: result.data });
      //yield put({ type: `FETCH_SUCCESS_${__name}`, data: { result: 0 } })
    } catch (error) {
      console.log("ChangeConnectedAds error", error);
      yield put({ type: `FETCH_FAILURE_${__name}`, error });
    }
  },
  ClearChangeConnectedAdsResult: function* () {
    const __name = constants.CHANGE_CONNECTED_ADS;
    console.log("ClearChangeConnectedAdsResult", __name);
    yield put({ type: `FETCH_SUCCESS_${__name}`, data: {} });
  },
};
